import { negativeMatchTypes } from '@@/advertisement/common/constants';
import translateMatchTypes from '../../../common/utility/translators/translateMatchTypes';

export default translateMatchTypes(negativeMatchTypes);
